import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from "prop-types"

import SolarSystemState from'../userPaygoInfoProfile/profile-user-prod.jsx';
import ProfileBoxItemBoxStatus from '../userPaygoInfoProfile/profile-user-box.jsx';
import SolarInstallation from '../userPaygoInfoProfileDynamic/profile-user-solarinfo.jsx';
import ElectricEquipment from '../userPaygoInfoProfileDynamic/profile-user-electric-equipement.jsx';
import GenericInfo from '../userPaygoInfoProfileDynamic/profile-user-generic-info.jsx';
import StoreHouseEquipment from '../userPaygoInfoProfileDynamic/profile-user-electric-storeHouseEquipment.jsx';
import Geolocalisation from '../userPaygoInfoProfileDynamic/profile-user-geolocalisation.jsx';
import { Grid } from '@material-ui/core';

class Installs extends Component {
    static propTypes = {
        profile_list: PropTypes.array.isRequired, // "INSTALLS", "BOX", "SYSTEM", "EQUIPEMENT"
        userID: PropTypes.string,
        boxAssoId: PropTypes.string.isRequired
    };
    render (){
        const { profile_list, boxAssoId } = this.props;
        console.log('DEBUG],***************',this.props);
        return (
            <Grid container spacing={2}>
                {profile_list.includes("INSTALL") &&
                    <Grid item xs={12} >
                        <SolarInstallation boxAssoId={boxAssoId} />
                    </Grid>
                }
                {profile_list.includes("EQUIPEMENT") &&
                    <Grid item xs={12} >
                        <ElectricEquipment boxAssoId={ boxAssoId } />
                    </Grid>
                }
                {/* {profile_list.includes("INFO3") &&
                    <Grid item xs={12} >
                        <GenericInfo boxId={ paygoID } userId={ userID } InfoItem="info3"/>
                    </Grid>
                }
                {profile_list.includes("INFO4") &&
                    <Grid item xs={12} >
                        <GenericInfo boxId={ paygoID } userId={ userID } InfoItem="info4"/>
                    </Grid>
                } */}
                {profile_list.includes("SYSTEM") &&
                    <Grid item xs={12} >
                        <SolarSystemState boxAssoId={ boxAssoId }/>
                    </Grid>
                }
                {profile_list.includes("BOX") &&
                    <Grid item xs={12} >
                        <ProfileBoxItemBoxStatus boxAssoId={ boxAssoId }/>
                    </Grid>
                }
                {profile_list.includes("EQUIPEMENT_FROM_STORE_HOUSE") &&
                    <Grid item xs={12} >
                        <StoreHouseEquipment boxAssoId={ boxAssoId }/>
                    </Grid>
                }
                {profile_list.includes("GEOLOCALISATION") &&
                    <Grid item xs={12} >
                        <Geolocalisation boxAssoId={ boxAssoId } />
                    </Grid>
                }

                {/* <SolarInstallation userId={this.state.userId}/>
                <SolarSystemState boxId={this.state.boxId}/>
                <ProfileBoxItemBoxStatus boxId={this.state.boxId}/>
                <ElectricEquipment boxId={this.state.boxId} userId={this.state.userId}/> */}
                                        
            </Grid>
        )
    }
}

export default Installs;